import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "dialog-footer" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode("关闭")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    modelValue: _ctx.addOrEditDialog,
    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.addOrEditDialog) = $event)),
    "custom-class": "FormDialogBox",
    width: "700px",
    title: '迭代' + _ctx.addOrEditTypeTitle[_ctx.addOrEditType],
    onClose: _cache[8] || (_cache[8] = ($event: any) => (_ctx.addOrEditCancel()))
  }, {
    footer: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_el_button, {
          type: "danger",
          onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.addOrEditDialog = false))
        }, {
          default: _withCtx(() => [
            _hoisted_2
          ]),
          _: 1
        }),
        (_ctx.addOrEditType !== 2)
          ? (_openBlock(), _createBlock(_component_el_button, {
              key: 0,
              loading: _ctx.determineBtnLoading,
              type: "primary",
              onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.addOrEditDetermine()))
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.addOrEditTypeTitle[_ctx.addOrEditType]), 1)
              ]),
              _: 1
            }, 8, ["loading"]))
          : _createCommentVNode("", true)
      ])
    ]),
    default: _withCtx(() => [
      _createVNode(_component_el_form, {
        class: "addForm disabledFormShow",
        model: _ctx.addOrEditForm,
        rules: _ctx.addOrEditRules,
        ref: "addOrEditFormRef",
        "label-width": "auto",
        disabled: _ctx.formDisabled
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_form_item, {
            label: "迭代名称",
            prop: "name"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                modelValue: _ctx.addOrEditForm.name,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.addOrEditForm.name) = $event)),
                placeholder: "请输入迭代名称",
                clearable: ""
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, {
            label: "迭代负责人",
            prop: "user_id_type1"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_select, {
                modelValue: _ctx.addOrEditForm.user_id_type1,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.addOrEditForm.user_id_type1) = $event)),
                clearable: "",
                filterable: "",
                placeholder: "请选择迭代负责人"
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.membersProjectList, (item) => {
                    return (_openBlock(), _createBlock(_component_el_option, {
                      key: item.user_id,
                      label: item.username,
                      value: item.user_id
                    }, null, 8, ["label", "value"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, {
            label: "项迭代成员",
            prop: "user_ids_type2"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_select, {
                modelValue: _ctx.addOrEditForm.user_ids_type2,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.addOrEditForm.user_ids_type2) = $event)),
                multiple: "",
                clearable: "",
                filterable: "",
                placeholder: "请选择项迭代成员"
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.membersProjectList, (item) => {
                    return (_openBlock(), _createBlock(_component_el_option, {
                      key: item.user_id,
                      label: item.username,
                      value: item.user_id
                    }, null, 8, ["label", "value"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, {
            label: "迭代时间段：",
            prop: "date"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_date_picker, {
                modelValue: _ctx.addOrEditForm.date,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.addOrEditForm.date) = $event)),
                "range-separator": "至",
                type: "daterange",
                "start-placeholder": "开始时间",
                "end-placeholder": "结束时间",
                clearable: "",
                format: "YYYY-MM-DD",
                "value-format": "YYYY-MM-DD"
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, {
            label: "迭代目标",
            prop: "target",
            style: {"width":"100%"}
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                modelValue: _ctx.addOrEditForm.target,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.addOrEditForm.target) = $event)),
                type: "textarea",
                rows: 5,
                placeholder: "请输入迭代目标",
                clearable: ""
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["model", "rules", "disabled"])
    ]),
    _: 1
  }, 8, ["modelValue", "title"]))
}